import { ComponentStyleConfig } from "@chakra-ui/react";

const Modal: ComponentStyleConfig = {
  baseStyle: { dialog: { mx: 5 } },
};

export default Modal;
